import Image from "next/image"
import styles from "./forestry.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import forestry from "../../assets/images/upsc/FORESTRY-OPTIONAL-Web-Banner.jpg";
import Link from "next/link";

const Forestry_Geology_Optional_Programme = () => {
    return (
        <>
        <Navbar title="upsc" />
       
            <div className="container">
                <div className="row">
                <div className="col pt-3 pt-md-5">
                    <h1 className={`${styles.pagemaintitle}`}>Forestry & Geology Optional Programme</h1>
                </div>
                </div>
                <div className="row">
                <div className="col pt-2 mb-3">
                    <Image src={forestry}
                      alt="Forestry banner" 
                      title="Forestry & Geology Optional Programme" 
                      className="img-fluid w-100" 
                    />
                </div>
                </div>
                <div className="row pt-2">
                <div className="col-md-9 col-12">
                    <h2 className={`${styles.sectiontitle} mb-0`}>Admission open for Forestry & Geology Optional Programme</h2>
                </div>
                </div>
                </div>

         <div className="container">
            <div className="row pt-md-4 pt-3">
                <div className="col">
                <p className={`${styles.sectionsubtitle} mb-2`}>Forestry Optional</p>
                </div>
            </div>
        </div>

        {/* table 1*/}
        <div className="container">
            <div className="row pt-3">
                <div className="col">
                <div className={`${styles.tablescroll} prelimstable`}>
                        <table className="table">
                            <thead className="table" style={{backgroundColor:"#818C98"}}>
                                <tr>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Optional</td>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Duration</td>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Starts on</td>
                                    {/* <td className={`${styles.tableheading}`} id={styles.bgcolor}>Test Schedule</td> */}
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Admission</td>
                                </tr>
                        </thead>
                        <tbody>
                                <tr className="pt-2">
                                    <td className={`${styles.tablepara}`}>FORESTRY OPTIONAL - 2023</td>
                                    <td className={`${styles.tablepara}`}>6 WEEKS (WEEKEND COURSE<br />(OFFLINE AND ONLINE ) VC - ALL BRANCHES )
                                    </td>
                                    <td className={`${styles.tablepara}`}>30th September 2023<br />Time : 01:30 pm - 07:00 pm</td>
                                    {/* <td><Link href="/pdf/forestry-geology-optional-programme/FORESTRY-TEST-BATCH-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    
                                </tr>
                                <tr className="pt-2">
                                    <td className={`${styles.tablepara}`}>GEOLOGY OPTIONAL - WEEKEND</td>
                                    <td className={`${styles.tablepara}`}>6 WEEKS (INCLUSIVE OF 4+2 TEST<br />AND ANSWER WRITING PRACTICE),<br />WEEKLY 3 DAYS (EVERY WED , THR, FRI )    </td>
                                    <td className={`${styles.tablepara}`}>07 OCTOBER 2023<br />Time : 02:00 pm - 05:30 pm</td>
                                    {/* <td><Link href="/pdf/forestry-geology-optional-programme/GEOLOGY-TEST-BATCH-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td> */}
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>                           
                                </tr>                           
                            </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>   

        <div className="container">
        <div className="row pt-2">
                <div className="col-md-9 col-12">
                    <h2 className={`${styles.sectiontitle} mb-0`}>Forestry Test Batch - Schedule</h2>
                </div>              
            </div>
        </div>
                
        <div className="container">
            <div className="row pt-md-4 pt-3">
                <div className="col">
                <p className={`${styles.sectionsubtitle} mb-2`}>Forestry Test Batch</p>
                </div>
            </div>
        </div>

        {/* table 2*/}
        <div className="container">
            <div className="row pt-3">
                <div className="col">
                <div className={`${styles.tablescroll} prelimstable`}>
                        <table className="table">
                            <thead className="table" style={{backgroundColor:"#818C98"}}>
                                <tr>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Optional</td>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Starts on</td>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Test Schedule</td>
                                    <td className={`${styles.tableheading}`} id={styles.bgcolor}>Admission</td>
                                </tr>
                        </thead>
                        <tbody>
                                <tr className="pt-2">
                                    <td className={`${styles.tablepara}`}>FORESTRY TEST BATCH – SCHEDULE</td>
                                    <td className={`${styles.tablepara}`}>07th October 2023</td>
                                    <td><Link href="/pdf/forestry-geology-optional-programme/FORESTRY-TEST-BATCH-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    
                                </tr>
                                <tr className="pt-2">
                                    <td className={`${styles.tablepara}`}>GEOLOGY TEST BATCH – SCHEDULE</td>
                                <td className={`${styles.tablepara}`}>14th October 2023</td>
                                    <td><Link href="/pdf/forestry-geology-optional-programme/GEOLOGY-TEST-BATCH-SCHEDULE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                                    <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>                       
                                </tr>                      
                            </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>   

    <div className="container">
    <div className="row pt-md-4 pt-3">
        <div className="col">
            <p className={`${styles.sectionsubtitle} mb-2 mb-md-3`}>Overview</p>
        </div>
    </div>
    <div className="row">
        <div className="col">
            <p className={`${styles.acheiverrank} mb-0`}>Aspiring to get into the prestigious IFS services? Shankar IAS Academy is your go-to IFS coaching centre for top-notch Indian Forest Service coaching in Chennai . The IFS Coaching centre in Chennai  offers forestry optional coaching and geology optional coaching for IFS aspirants. The IFS Coaching Centre offers optional test series for forestry, agriculture, and mathematics. Students can also choose from Forestry Crash course or Forestry Optional Classes as per their learning needs.</p>
        </div>
    </div>
    </div>

    <div className="container">
    <div className="row pt-md-4 pt-3">
        <div className="col">
            <p className={`${styles.sectionsubtitle} mb-2 mb-md-3`}>IFS Coaching</p>
            <p className={`${styles.sectionsubtitle} mb-2 mb-md-3`}>5 Reasons Why We are the Best Indian Forest Service Coaching Centre in Chennai</p>
        </div>
    </div>
    <div className="row">
        <div className="col">
        <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Consistent Results: &nbsp;</span><span className={`${styles.acheiverrank}`}> With close to 2 decades of providing meticulous and focused IAS, IFS, and UPSC coaching, Shankar IAS Academy has an unbeatable track record of top results in all these exams. More than 1000 of our students have been chosen for IAS, IPS, and other elite service sectors.</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Interactive Learning: &nbsp;</span><span className={`${styles.acheiverrank}`}> All our courses have been designed to include active student-achiever interaction. Aspirants are in constant touch with successful and serving IAS, IFS, and IPS officers who have passed out from our academy.</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Free Interview Guidance: &nbsp;</span><span className={`${styles.acheiverrank}`}> We offer free coaching for personality tests and mock interviews.</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Online Classes: &nbsp;</span><span className={`${styles.acheiverrank}`}> We are the first online coaching centre that offers 2-way LIVE communication</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Mentorship Program: &nbsp;</span><span className={`${styles.acheiverrank}`}> All our students are offered 360° mentoring by expert faculty to shape their perspectives and opinions.</span>
                    </p>
                </div>
            </li>
            
        </ul>
        <p className={`${styles.acheiverrank} mb-0`}><b>Enroll with the best IFS Coaching in Chennai for resounding success in the IFS exams.</b></p> 
        </div>
    </div>
    </div>
    <Footer />                      
        </>
    )
  } 
export default Forestry_Geology_Optional_Programme